'use strict';

function PositionService ($document, $window, sbPositionUtil) {
  
  /**
   * Calculate the css top/left position of the target element adjusted for the desired
   * alignment
   *
   * @param  {Object}  element - Angular jqLite wrapped DOM node
   * @param  {Array}   position - xy coordinates that the dialog should be placed at
   * @param  {String}  alignment - point on the box that should be aligned with the xy position
   */
  this.getAdjustedPosition = function (element, position, alignment) {
    var elementRect = {};

    alignment = normalizeAlignment(alignment);

    // adjust alignment to make sure the element remains inside the parent bounding box
    alignment = adjustAlignment(element, position, alignment);

    // calculate the position (aka element rectangle)
    elementRect = sbPositionUtil.getElementRectangle(element, position, alignment);

    return elementRect;
  };

  function adjustAlignment (element, position, alignment) {
    var wrapperEl = sbPositionUtil.getParentOffsetNode(element);
    var wrapperRect = wrapperEl.getBoundingClientRect();
    var elementRect = sbPositionUtil.getElementRectangle(element, position, alignment);

    if ((elementRect.left + wrapperRect.left) < wrapperRect.left) {
      // too far left
      alignment.x = 'left';
    } else if (elementRect.right + wrapperRect.left > wrapperRect.right) {
      // too far right
      alignment.x = 'right';
    }

    if ((elementRect.top + wrapperRect.top) < wrapperRect.top) {
      // too far up
      alignment.y = 'top';
      
    } else if ((elementRect.bottom + wrapperRect.top) > wrapperRect.bottom) {
      // too far down
      alignment.y = 'bottom';
    }

    return alignment;
  }

  function normalizeAlignment (alignment) {
    var normalized = {
      x: '',
      y: ''
    };

    var possibleY = ['center', 'top', 'bottom'];
    var possibleX = ['center', 'left', 'right'];

    var arr = alignment.split(' ');

    if (!!~possibleX.indexOf(arr[0]) && 
        !!~possibleY.indexOf(arr[1])) {
      normalized.x = arr[0];
      normalized.y = arr[1];
    } else if (!!~possibleX.indexOf(arr[1]) &&
        !!~possibleY.indexOf(arr[0])) {
      normalized.x = arr[1];
      normalized.y = arr[0];
    } else {
      throw new Error('The alignment "'+ alignment +'" is not recognized.');
    }

    return normalized;
  }
}

module.exports = PositionService;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/position/PositionService.js